import React, {
    useContext
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import EgLogo from '../EgLogo';
import TranslationUtil from '../../utils/TranslationUtil';
import EgHeaderCta from './cta';
import { DomUtilsCtx } from '../../contexts/domUtils';

export function LypHeader(props) {
    const {
        getFooterLinks,
        logoText
    } = props;

    const {
        isTopOfPage
    } = useContext(DomUtilsCtx);

    // eslint-disable-next-line react/prop-types
    return (
        <nav
            className={classNames(
                'navbar',
                {
                    'header-scroll-not-top': !isTopOfPage
                }
            )}
        >
            <div
                className={classNames('header')}
            >
                <div className="logo">
                    <EgLogo callStatus={getFooterLinks} />
                    <span>
                        {logoText}
                    </span>
                </div>
                <EgHeaderCta />
            </div>
        </nav>
    );
}

LypHeader.propTypes = {
    getFooterLinks: PropTypes.shape({
        start: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        fail: PropTypes.bool.isRequired
    }).isRequired,
    logoText: PropTypes.string.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app } = state;
    const {
        getFooterLinks
    } = app;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const logoText = translations.getTranslation('lyp.header.logo.text');

    return {
        getFooterLinks,
        logoText
    };
};

const ConnectedLypHeader = connect(mapStateToProps)(LypHeader);
export default ConnectedLypHeader;
